import { CartUpdateEvent } from '@theme/events';

const OPEN_CART_PARAM = 'pindoo_open_cart';
const OPEN_CART_SOURCE = 'pindoo-creator';

function removeOpenCartParam(url) {
  url.searchParams.delete(OPEN_CART_PARAM);
  const search = url.searchParams.toString();
  const nextUrl = `${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
  window.history.replaceState({}, '', nextUrl || '/');
}

async function fetchCart() {
  const response = await fetch('/cart.js', {
    headers: {
      Accept: 'application/json',
    },
    cache: 'no-store',
  });

  if (!response.ok) {
    throw new Error(`Cart fetch failed: ${response.status}`);
  }

  return response.json();
}

async function openCartDrawerFromCreator() {
  const url = new URL(window.location.href);
  if (url.searchParams.get(OPEN_CART_PARAM) !== '1') return;

  removeOpenCartParam(url);

  await customElements.whenDefined('cart-drawer-component');

  const cartDrawer = document.querySelector('cart-drawer-component');
  if (!cartDrawer || typeof cartDrawer.open !== 'function') {
    window.location.assign('/cart');
    return;
  }

  try {
    const cart = await fetchCart();
    document.dispatchEvent(
      new CartUpdateEvent(cart, OPEN_CART_SOURCE, {
        itemCount: cart.item_count,
        source: OPEN_CART_SOURCE,
      })
    );
  } catch (error) {
    console.warn('Pindoo creator cart refresh failed before opening drawer.', error);
  }

  cartDrawer.open();
}

openCartDrawerFromCreator().catch((error) => {
  console.warn('Pindoo creator cart drawer bridge failed.', error);
});
